






import { PlanosService } from "@/services/planos.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: number;
}

@Component
export default class ComboPlanos extends Vue {
  @Prop() idConsultor!: number;
  @Prop(Number) readonly value!: number | undefined;
  @Prop({
    type: Array,
    default: () => [],
  }) readonly rules!: ((v: unknown) => string | true)[];

  loading = false;

  tipo: ComboItem | null = null;
  itemsTipo: ComboItem[] = [];

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  async fetchTipos() {
    this.loading = true;
    const res = await PlanosService.listarTiposAtivosNaoGratuitos();
    this.itemsTipo = res.map((x) => ({
      text: x.nome,
      value: x.idTipoPlano,
    }));

    if (this.value) {
      this.tipo = this.itemsTipo.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  async mounted() {
    await this.fetchTipos();
  }
}
